import { Typography } from "@mui/material";
import React from "react";

const NotFoundPage = () => {
  return (
    <Typography variant="h1" color="black" sx={{ textAlign: "center" }}>
      404 NOT FOUND
    </Typography>
  );
};

export default NotFoundPage;
